<template>
  <header>
    <div id="city_contact">
      <span class="mr-2 d-inline-block">
        <span class="mr-2" v-if="!!(cityPhone || cityMail)">Besoin d'aide ?</span>
        <span class="mr-2" v-if="!!cityPhone">
          <a :href="'tel:' + cityPhone">
            <font-awesome-icon class="icon" icon="phone" />
            <span class="pl-1">{{ cityPhone }}</span>
          </a>
        </span>
        <span class="mr-2" v-if="!!cityMail">
          <a class :href="'mailto:' + cityMail">
            <font-awesome-icon class="icon" icon="envelope" />
            <span class="pl-1">{{ cityMail }}</span>
          </a>
        </span>
      </span>
    </div>
    <div id="connect_button" v-if="canConnect">
      <router-link to="/login">
        <button type="button" class="btn">
          <span class="large-connect">SE CONNECTER</span>
          <font-awesome-icon class="icon fa-lg small-connect" icon="sign-in-alt" />
        </button>
      </router-link>
    </div>
  </header>
</template>

<script>
import store from '@/store'

export default {
  name: 'app-footer',
  props: {
    canConnect: Boolean
  },
  computed: {
    isUserLoggedIn () {
      return store.getters.isLoggedIn
    },
    userLoggedIn () {
      return store.getters.user
    },
    cityPhone () {
      return store.getters.configuration.cityPhone
    },
    cityMail () {
      return store.getters.configuration.cityMail
    }
  }
}
</script>

<style scoped>
header {
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
  padding: 0.5rem 0;
  height: 4rem;
  position: relative;
  display: flex;
  align-items: center;
  background-color: #3a3a3a;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  color: #fff;
  font-size: 0.9rem;
}

header #city_contact {
  padding: 0 1rem;
}

header #connect_button {
  position: absolute;
  top: calc(2.5rem * 1.3);
  right: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  width: 3rem;
  background-color: #fff;
  transform: skew(0deg, -2deg);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0);
  transition: all 0.35s ease;
}

header #connect_button button {
  font-size: 1.4rem;
  letter-spacing: -0.1rem;
  width: 100%;
  border-radius: 0;
}

header #connect_button button:focus {
  box-shadow: none;
}

header #connect_button:hover {
  background-color: var(--theme-color);
  box-shadow: 0 0 20px 0 rgba(255, 255, 255, 0.5);
  transform: skew(0deg, -2deg) scale(1.15);
}

header #connect_button:hover button {
  color: #fff;
}

.large-connect {
  display: none;
}

.small-connect {
  display: block;
}

.small-text {
  font-size: 75%;
  line-height: 100%;
}

header a {
  color: rgba(255, 255, 255, 0.7);
  font-weight: normal;
}

header a:hover {
  color: #fff;
  text-decoration: none;
}

@media (min-width: 768px) {
  header {
    height: 2.5rem;
  }

  header #connect_button {
    top: 50%;
  }

  header #connect_button {
    width: 12rem;
  }

  .large-connect {
    display: block;
  }

  .small-connect {
    display: none;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  header #connect_button:hover {
    background-color: lightseagreen;
  }

  header #connect_button {
    border: 1px solid lightseagreen;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-info-bar.vue